module.exports = __webpack_public_path__ + "img/instagram.6e52b2a1.png";